module.exports = __webpack_public_path__ + "static/media/freddy.a3eb8395.png";